import styled from 'styled-components';

export const DetailsWrapper = styled.div`
  padding: 6px;
`;

export const DetailsHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;
